module.exports = __webpack_public_path__ + "assets/img/36_559_big.342c1466.jpg";